import React,{ Component, useState, useRef,useEffect } from "react"
import { useProject } from "../Providers"
import axios from "axios"
import style from "../common/setting.module.scss"
import ControlPanel from "../ControlPanel"
import CSVReader from "react-csv-reader";

const iconv = require('iconv-lite');

export default function BusDB() {
	const { setting, setSetting } = useProject()
	const [viadatas, setViadatas] = useState([]);
	const [msg, setMsg] = useState("") 
	const [msg1, setMsg1] = useState("") 
	const [form, setForm] = useState({
		region : "",
		company : "", 
		region1 : "",
		company1 : "", 
	})	
	
	// let htmlToDraft = null;
	// if (typeof window === 'object') {
	// 	htmlToDraft = require('html-to-draftjs').default;
	// }
	const htmlToDraft = typeof window === 'object' && require('html-to-draftjs').default;

	useEffect(() => {
		if(setting && setting.company ) {
			setForm({...form, 
				region : setting.region,
				company : setting.company, 
				region1 : setting.region,
				company1 : setting.company, 
			})
		}
	}, [setting && setting.company? setting.company:null]);	

	useEffect(() => {
		if(setting && setting.bus ) {
			setForm({...form, 
				busno: setting.bus.busno,
				busid: setting.bus.busid,
				led: setting.bus.led,
				dir: setting.bus.dir,
				startname: setting.bus.startname,
				endname: setting.bus.endname,
				via: setting.bus.via,
				starteng: setting.bus.starteng,
				endeng: setting.bus.endeng,
				viaeng: setting.bus.viaeng,
				res1: setting.bus.res1,
				res2: setting.bus.res2,
			})

			setSetting({
				...setting,
				bus: null,
			})
		}
	}, [setting && setting.bus? setting.bus:null]);	

	const dateToString = (date) => {
		return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0')
	}

	const handleChange = (e) =>{
		setForm({
			...form,
			[e.target.name]: e.target.value,
		})
		setMsg('');
	}

	const handleSubmit = () => {
		if (
			form.textno === "" ||
			form.textname === ""
		)
			return
		//onClose()
	}

	const ViaDatahandler = (data, fileInfo) => {
		setViadatas(data)
		setMsg( data.length + 'ea data.')
	}

	const handleVia = async (event, value) => {
		event.preventDefault();
		if(viadatas.length == 0){
			setMsg('select csv file');
		}
		else addViaInfo()
	}

	const addViaInfo = async() => {

		if(viadatas.length == 0){
			setMsg('select csv file');
			return;
		}

		var busarr = [];
		var seq=0
		viadatas.map((via)=>{
			busarr.push({
				resion: String(form.region1),
				company: String(form.company1),
				busno: String(via.busno),
				busid: String(via.routeid),
				led: String(via.led),
				dir: String(via.dir),
				busname: `${via.led}${via.busno}${via.dir}`,
				//startname: via.depart? iconv.decode(via.depart,'euc-kr'):'',
				//endname: via.arrival? iconv.decode(via.arrival,'euc-kr'):'',
				//via:(via.via)? iconv.decode(via.via,'euc-kr'):'',
				startname: via.depart? via.depart:'',
				endname: via.arrival? via.arrival:'',
				via:(via.via)? via.via:'',
				starteng:(via.depenglish)?via.depenglish:'',
				endeng:(via.arrenglish)?via.arrenglish:'',
				viaeng: (via.viaenglish)?via.viaenglish:'',
				res1: String(via.res1),
				res2: String(via.res2),
				memo:'',
			});
		})

		setMsg('Uploading')

		const token = localStorage.getItem('accessToken');
		if (token === null) {
			alert('please login!');
			window.location.reload();
		}
		try {
			const resp = await axios.post(`${process.env.REACT_APP_PUBLIC_API_URL}/businfo`,
			{
				busarr
			},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
			
			if (resp.data.ok) {
				setMsg('Upload completed')

				setSetting({
					...setting,
					buschg : 1,
				})
			} else {
				setMsg(resp.data.message)
			}
		} catch (err) {

		}
	}
	const papaparseOptions = {
		header: true,
		dynamicTyping: true,
		skipEmptyLines: true,
		transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
	};

	const handleApply = async (event, value) => {
		event.preventDefault();
		const link = document.createElement( 'a' );
		link.style.display = 'none';
		document.body.appendChild( link );

		let date = new Date();
		// var verno = date.getFullYear().toString().substring(2,4) + (date.getMonth() + 1).toString().padStart(2, '0') 
		// 		+ date.getDate().toString().padStart(2, '0') + date.getHours().toString().padStart(2, '0')
		// 		+ date.getMinutes().toString().padStart(2, '0') + date.getSeconds().toString().padStart(2, '0')
		let filename = form.led + form.busno + form.dir; //파일명
		let bytes = new Uint8Array(1024);
		for(let i=0; i<filename.length; i++) bytes[i]=filename.charCodeAt(i) 
		let str1 = form.led + form.busid + form.dir; //파일명
		for(let i=0; i<str1.length; i++) bytes[i+0x10]=str1.charCodeAt(i)  
		bytes[0x20] = Number('0x'+date.getFullYear().toString().substring(2,4)); //날짜
		bytes[0x21] = Number('0x'+date.getMonth().toString().padStart(2, '0')); 
		bytes[0x22] = Number('0x'+date.getDate().toString().padStart(2, '0')); 
		bytes[0x23] = Number('0x'+date.getHours().toString().padStart(2, '0')); 
		bytes[0x24] = Number('0x'+date.getMinutes().toString().padStart(2, '0')); 
		bytes[0x25] = Number('0x'+date.getSeconds().toString().padStart(2, '0')); 
		for(let i=0; i<4; i++) bytes[i+0x26]= 0xFF;
		bytes[0x2B]= 0x01;	bytes[0x41]= 0x48;	bytes[0x43]= 0x1E;	bytes[0x48]= 0x44;	bytes[0x49]= 0x45; //고정
		bytes[0x2B]=bytes[0x2B]=0x01;
		const decbusname = iconv.encode(form.busno, 'euc-kr');
		for(let i=0; i<decbusname.length; i++) bytes[i+0x4C]=decbusname[i]//버스번호
		const decstartname = iconv.encode(form.startname, 'euc-kr');
		for(let i=0; i<decstartname.length; i++) bytes[i+0x6C]=decstartname[i]//출발지
		const decendname = iconv.encode(form.endname, 'euc-kr');
		for(let i=0; i<decendname.length; i++) bytes[i+0x8C]=decendname[i]//도착지

		for(let i=0; i<form.starteng.length; i++) bytes[i+0xAC]=form.starteng.charCodeAt(i)//출발지 eng
		for(let i=0; i<form.endeng.length; i++) bytes[i+0xCC]=form.endeng.charCodeAt(i)//도착지 eng

		const decviastopnames = iconv.encode(form.via, 'euc-kr');
		for(let i=0; i<decviastopnames.length; i++) bytes[i+0xEC]=decviastopnames[i]//경유지

		for(let i=0; i<form.viaeng.length; i++) bytes[i+0x1AC]= form.viaeng.charCodeAt(i)//경유지 eng
		const resid1 = iconv.encode(form.res1, 'euc-kr');
		for(let i=0; i<resid1.length; i++) bytes[i+0x26C]= resid1[i]//res1
		const resid2 = iconv.encode(form.res2, 'euc-kr');
		for(let i=0; i<resid2.length; i++) bytes[i+0x28C]= resid2[i]//res2

		bytes[0x2AC] = 0x0D; bytes[0x2AD]=0x0A; 

		const blob = new Blob( [ bytes ], { type: 'application/octet-stream' } )
		link.href = URL.createObjectURL( blob );
		link.download = filename+".ebs";
		link.click();
	}

	const handleAdd = async (event, value) => {
		event.preventDefault();

		if ( form.region =='' || form.company =='' || form.busno ==''){
			setMsg("Input data");
			return
		}

		const token = localStorage.getItem('accessToken');
		if (token === null) {
			alert('please login!');
			window.location.reload();
		}

		var busarr = [{
			resion : form.region,
			company : form.company,
			busno : form.busno,
			busid : form.busid,
			led : form.led,
			dir : form.dir,
			busname : `${form.led}${form.busno}${form.dir}`,
			startname : form.startname,
			endname : form.endname,
			starteng : form.starteng,
			endeng : form.endeng,
			via : form.via,
			viaeng : form.viaeng,
			res1 : form.res1,
			res2 : form.res2,
		}]

		try {
			const resp = await axios.post(`${process.env.REACT_APP_PUBLIC_API_URL}/businfo`,
			{
				busarr
			},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
			setForm({
				...form,
				msg: resp.data.message
			})

			setSetting({
				...setting,
				buschg : 1,
			})
			
		} catch (err) {
			alert(err);
		}
	};

	const handleDel = async (event, value) => {
		event.preventDefault();

		if ( form.region =='' || form.company =='' || form.busno ==''){
			setMsg("Input data");
			return
		}

		const token = localStorage.getItem('accessToken');
		if (token === null) {
			alert('please login!');
			window.location.reload();
		}
		try {
			const resp = await axios.delete(`${process.env.REACT_APP_PUBLIC_API_URL}/businfo`,{
				data : {
					resion : form.region,
					company : form.company,
					busid : form.busid,
				},
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
			if (resp.data.ok) {
				setMsg('deleted');

				setSetting({
					...setting,
					buschg : 1,
				})
			} else {
				setMsg(resp.data.message)
			}
		} catch (err) {
			alert(err);
		}
	};

	return (
		<div className = {style.defaultModal} style={{ display: 'flex', marginLeft:'10px', marginTop: '50px'}}>
			<div style={{  flex: '20%', marginLeft:'20px', width:'500px'}}>	
				<div className={style.wrapper2} style={{ width:"220px", height:"480px"}}>
					<label className={style.linecs} style={{marginTop:'-8px'}}>CSV Uplaod Bus Route</label>
					<div>
					<label className={style.label} style={{marginLeft:'-8px'}}>Region : </label>
					<input
							className={style.input} type='text' name='region' placeholder='region'
							style={{ width: '90px', marginLeft:'8px',marginBottom:'5px'}}
							maxLength='16' value={form.region} onChange={handleChange} spellCheck="false"
					/>
					<label className={style.label} style={{marginLeft:'-8px'}}>Company : </label>
					<input
							className={style.input} type='text' name='company'	placeholder='company'
							style={{ width: '90px', marginLeft:'-9px',marginBottom:'20px'}}
							maxLength='16' value={form.company} onChange={handleChange} spellCheck="false"
					/>
					</div>
					<div style={{ marginLeft:"10px",color:"#C3602C", marginTop:"10px"}} >Select CSV File
					<CSVReader
						cssClass="csv-reader-input"
						onFileLoaded={ViaDatahandler}
						parserOptions={papaparseOptions}
					/>
					</div>
					<button className={style.button} style={{ marginLeft:"60px", marginTop:"20px", marginBottom:"20px"}}  onClick={handleVia}>Upload</button>
					<div style={{ marginLeft:"10px",color:"#C3602C"}}> CSV header should be : </div>
					<div style={{ marginLeft:"10px"}}>Led,BusNo,Dir,RouteId,</div>
					<div style={{ marginLeft:"10px"}}>Depart,Arrival,</div>
					<div style={{ marginLeft:"10px"}}>DepEnglish,ArrEnglish,</div>
					<div style={{ marginLeft:"10px"}}>Via,ViaEnglish,</div>
					<div style={{ marginLeft:"10px"}}>Res1,Res2</div>
					<div style={{ marginLeft:"10px",color:"#C3602C", marginTop:"10px"}} >* Use UTF-8 encoding *</div>
				</div>
				<label className={style.label} style={{ color:"#C3602C", marginTop:"10px"}} value={msg}>{msg}</label>
			</div>
			<div style={{  flex: '40%', marginLeft:'40px'}}>	
				<div className={style.wrapper2} style={{ width:"430px", height:"600px"}}>
					<label className={style.linecs} style={{marginTop:'-8px'}}>Bus Route Edit</label>
					<div>
					<label className={style.label} style={{marginLeft:'-8px'}}>Region </label>
					<input
							className={style.input} type='text' name='region1' placeholder='region1'
							style={{ width: '100px', marginLeft:'8px',marginBottom:'5px'}}
							maxLength='16' value={form.region1} onChange={handleChange} spellCheck="false"
					/>
					<label className={style.label} style={{marginLeft:'-8px'}}>Company </label>
					<input
							className={style.input} type='text' name='company1'	placeholder='company1'
							style={{ width: '100px', marginLeft:'-9px',marginBottom:'5px'}}
							maxLength='16' value={form.company1} onChange={handleChange} spellCheck="false"
					/>
					<label className={style.label} style={{marginLeft:'-8px'}}>Led &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</label>
					<input
							className={style.input} type='text' name='led'	placeholder='led'
							style={{ width: '100px', marginLeft:'-9px',marginBottom:'5px'}}
							maxLength='16' value={form.led} onChange={handleChange} spellCheck="false"
					/>
					<label className={style.label} style={{marginLeft:'-8px'}}>Bus No &nbsp; &nbsp;</label>
					<input
							className={style.input} type='text' name='busno'	placeholder='busno'
							style={{ width: '100px', marginLeft:'-9px',marginBottom:'5px'}}
							maxLength='16' value={form.busno} onChange={handleChange} spellCheck="false"
					/>
					<label className={style.label} style={{marginLeft:'-8px'}}>Direction &nbsp;</label>
					<input
							className={style.input} type='text' name='dir'	placeholder='direction'
							style={{ width: '100px', marginLeft:'-9px',marginBottom:'5px'}}
							maxLength='16' value={form.dir} onChange={handleChange} spellCheck="false"
					/>
					<label className={style.label} style={{marginLeft:'-8px'}}>Route ID &nbsp;</label>
					<input
							className={style.input} type='text' name='busid'	placeholder='routeid'
							style={{ width: '100px', marginLeft:'-9px',marginBottom:'5px'}}
							maxLength='16' value={form.busid} onChange={handleChange} spellCheck="false"
					/>
					<label className={style.label} style={{marginLeft:'-8px'}}>Depart &nbsp; &nbsp; </label>
					<input
							className={style.input} type='text' name='startname'	placeholder='depart'
							style={{ width: '100px', marginLeft:'-9px',marginBottom:'5px'}}
							maxLength='16' value={form.startname} onChange={handleChange} spellCheck="false"
					/>
					<label className={style.label} style={{marginLeft:'-8px'}}>Arrival &nbsp; &nbsp; &nbsp;</label>
					<input
							className={style.input} type='text' name='endname'	placeholder='arrival'
							style={{ width: '100px', marginLeft:'-9px',marginBottom:'5px'}}
							maxLength='16' value={form.endname} onChange={handleChange} spellCheck="false"
					/>
					<label className={style.label} style={{marginLeft:'-8px'}}>Depart &nbsp; &nbsp; </label>
					<input
							className={style.input} type='text' name='starteng'	placeholder='dep.. english'
							style={{ width: '100px', marginLeft:'-9px',marginBottom:'5px'}}
							maxLength='16' value={form.starteng} onChange={handleChange} spellCheck="false"
					/>
					<label className={style.label} style={{marginLeft:'-8px'}}>Arrival &nbsp; &nbsp; &nbsp;</label>
					<input
							className={style.input} type='text' name='endeng'	placeholder='arr.. english'
							style={{ width: '100px', marginLeft:'-9px',marginBottom:'5px'}}
							maxLength='16' value={form.endeng} onChange={handleChange} spellCheck="false"
					/>
					<div>
					<label className={style.label} style={{marginLeft:'-8px'}}>Waypoint </label>
					</div>
					<textarea
							className={style.input} type='text' name='via'	placeholder='viawaypoint'
							style={{ width: '380px', height:'56px', marginLeft:'10px',marginBottom:'5px'}}
							maxLength='16' value={form.via} onChange={handleChange} spellCheck="false"
					/>
					<div>
					<label className={style.label} style={{marginLeft:'-8px'}}>Waypoint(English) </label>
					</div>
					<textarea
							className={style.input} type='text' name='viaeng'	placeholder='way.. Engligh'
							style={{ width: '380px', height:'56px',marginLeft:'10px',marginBottom:'5px'}}
							maxLength='16' value={form.viaeng} onChange={handleChange} spellCheck="false"
					/>
					<label className={style.label} style={{marginLeft:'-8px'}}>Residual1</label>
					<input
							className={style.input} type='text' name='res1'	placeholder='residual 1'
							style={{ width: '100px', marginLeft:'-9px',marginBottom:'5px'}}
							maxLength='16' value={form.res1} onChange={handleChange} spellCheck="false"
					/>
					<label className={style.label} style={{marginLeft:'-8px'}}>Residual2</label>
					<input
							className={style.input} type='text' name='res2'	placeholder='residual 2'
							style={{ width: '100px', marginLeft:'-9px',marginBottom:'5px'}}
							maxLength='16' value={form.res2} onChange={handleChange} spellCheck="false"
					/>
					</div>
					<div style={{marginTop:'10px', marginLeft:'20px'}}>
					<button className={style.button} onClick={handleAdd}>Save</button>
					<button className={style.button} onClick={handleDel}>Delete</button>
					<button className={style.button} onClick={handleApply}>File</button>

					{/* <div style={{ marginLeft:"1px",color:"#C3602C", marginTop:"10px"}} >* Select Bus in Right Explorer Bar ...</div> */}
					
				</div>
				</div>
				<label className={style.label} style={{ color:"#C3602C", marginTop:"20px"}} value={msg1}>{msg1}</label>
			</div>
			<div style={{  flex: '40%', marginLeft:'20px'}}>	
				<label className={style.linecs} style={{marginBottom:'10px',marginLeft:'45%'}}>Select Bus Route</label>
				{<ControlPanel menu="bus" />}
			</div>
		</div>
	)
}
